import lang from '../../../lib/language';
import { PaymentReturnUrlTypeEnum, PurchasePaymentTypeEnum } from '../../../lib/models/crm/types';

import { UI_ROUTES } from '../../../util/routes';

type PlanPaymentSuccessPathParams = {
  withAutoPass: boolean;
  planId: number;
  paymentReference: string | null | undefined;
};

export const buildPlanPaymentSuccessPath = ({
  withAutoPass,
  planId,
  paymentReference,
}: PlanPaymentSuccessPathParams): string => {
  const params = new URLSearchParams({
    purchaseType: String(
      withAutoPass ? PurchasePaymentTypeEnum.PlanWithAutoPass : PurchasePaymentTypeEnum.Plan,
    ),
    callbackReturnType: String(PaymentReturnUrlTypeEnum.Success),
    planId: String(planId),
    paymentReferenceId: paymentReference ?? '',
  });

  return `${UI_ROUTES.paymentSuccess}?${params.toString()}`;
};

type PurchasePaymentSuccessPathParams = {
  purchaseType: PurchasePaymentTypeEnum;
  paymentReference: string | null | undefined;
};

export const buildPurchasePaymentSuccessPath = ({
  purchaseType,
  paymentReference,
}: PurchasePaymentSuccessPathParams): string => {
  const params = new URLSearchParams({
    purchaseType: String(purchaseType),
    callbackReturnType: String(PaymentReturnUrlTypeEnum.Success),
    paymentReferenceId: paymentReference ?? '',
  });

  const successPath = purchaseType === PurchasePaymentTypeEnum.AccountDailyLossRewind
    ? UI_ROUTES.dashboard
    : UI_ROUTES.planDetails;

  return `${successPath}?${params.toString()}`;
};

export const getCouponErrorMessage = (
  errorCode: string,
  purchaseType?: PurchasePaymentTypeEnum,
): string => {
  const isPlanPurchase = purchaseType === PurchasePaymentTypeEnum.Plan
  || purchaseType === PurchasePaymentTypeEnum.PlanWithAutoPass;

  switch (errorCode) {
    case 'COUPON_NOT_FOUND':
      return lang.paymentMethodCouponErrorNotFound();
    case 'COUPON_EXPIRED':
      return lang.paymentMethodCouponErrorExpired();
    case 'COUPON_INACTIVE':
      return lang.paymentMethodCouponErrorInactive();
    case 'PLAN_NOT_ELIGIBLE':
      return isPlanPurchase
        ? lang.paymentMethodCouponErrorPlanNotEligible()
        : lang.paymentMethodCouponErrorPurchaseNotEligible();
    case 'USER_NOT_ELIGIBLE':
      return lang.paymentMethodCouponErrorUserNotEligible();
    case 'USAGE_CAP_EXCEEDED':
      return lang.paymentMethodCouponErrorUsageCapExceeded();
    case 'COUPON_RATE_LIMITED':
      return lang.paymentMethodCouponErrorRateLimited();
    case 'COUPON_IDEMPOTENCY_CONFLICT':
    case 'QUOTE_NOT_FOUND':
    case 'QUOTE_EXPIRED':
    case 'QUOTE_ALREADY_USED':
    case 'QUOTE_MATERIAL_MISMATCH':
    case 'QUOTE_INTEGRITY_FAILURE':
      return lang.paymentMethodCouponErrorRefresh();
    default:
      return lang.paymentMethodCouponErrorDefault();
  }
};
